import { z } from 'zod';
import { PositionSchema } from '../../shared/position.schema';
import { DraftNodeEnvelopeSchema } from '../../entities/process-draft/draft-node-envelope.schema';
import { StepPositionSchema } from '../../entities/process-layout/process-layout.schema';
/**
 * POST /api/v2/process/:processId/draft/step-templates/:templateId/insert
 *
 * `position` is the lane-relative anchor the template's normalised positions
 * are offset from; `laneKey` is the same creation-time placement hint
 * `AddDraftStepRequestSchema` carries.
 */ export const InsertStepTemplateRequestSchema = z.object({
    position: PositionSchema,
    laneKey: z.string().optional()
});
/**
 * The draft-node envelope plus the layout rows the insert pushed for the nodes
 * it minted, so the client seeds its layout cache instead of guessing a
 * created-id order. Required — the insert always seeds every node it creates.
 */ export const InsertStepTemplateResponseSchema = DraftNodeEnvelopeSchema.extend({
    positions: z.array(StepPositionSchema)
});

//# sourceMappingURL=insert-step-template.schema.js.map